/*
 * @Descripttion:
 * @version:
 * @Author: 邓旭阳
 * @Date: 2022-01-17 10:02:27
 * @LastEditors: 邓旭阳
 * @LastEditTime: 2022-02-21 11:11:57
 */
import Environment from './Environment';
// const LOGIN_HEADER = '';
// const BigDataIframeSrc = '';
// const PAY_HEADER = '';

export default {
    // 用户接口
    getTreeData: Environment.API_HEADER + '/department/query',
    addTreeData: Environment.API_HEADER + '/department/add',
    modifyTreeData: Environment.API_HEADER + '/department/modify',
    deleteTreeData: Environment.API_HEADER + '/department/delete',
    getTableData: Environment.API_HEADER + '/user/query',
    addTableData: Environment.API_HEADER + '/user/add',
    modifyTableData: Environment.API_HEADER + '/user/modify',
    deleteTableData: Environment.API_HEADER + '/user/delete',
    getAccount:Environment.API_HEADER + '/user/account/query',

    // 用户权限接口
    getModuleconfig: Environment.API_HEADER + '/moduleconfig/query',
    addModuleconfig: Environment.API_HEADER + '/moduleconfig/add',
    modifyModuleconfig: Environment.API_HEADER + '/moduleconfig/modify',
    deleteModuleconfig: Environment.API_HEADER + '/moduleconfig/delete',

    // 大权限接口
    getAppconfig: Environment.API_HEADER + '/appconfig/query',
    addAppconfig: Environment.API_HEADER + '/appconfig/add',
    modifyAppconfig: Environment.API_HEADER + '/appconfig/modify',
    deleteAppconfig: Environment.API_HEADER + '/appconfig/delete',

    // 消息接口
    getmessageData: Environment.API_HEADER + '/message/query',
    addmessageData: Environment.API_HEADER + '/message/add',
    modifymessageData: Environment.API_HEADER + '/message/modify',
    deletemessageData: Environment.API_HEADER + '/message/delete',
    // 班组接口
    getrosterData: Environment.API_HEADER + '/team/query',
    addrosterData: Environment.API_HEADER + '/team/add',
    modifyrosterData: Environment.API_HEADER + '/team/modify',
    deleterosterData: Environment.API_HEADER + '/team/delete',
    // 人员排班接口
    getpersonData: Environment.API_HEADER + '/scheduling/query',
    addpersonData: Environment.API_HEADER + '/scheduling/add',
    modifypersonData: Environment.API_HEADER + '/scheduling/modify',
    deletepersonData: Environment.API_HEADER + '/scheduling/delete',
    // 应急通讯录
    getcommunicationlistData: Environment.API_HEADER + '/communicationlist/query',
    addcommunicationlistData: Environment.API_HEADER + '/communicationlist/add',
    modifycommunicationlistData: Environment.API_HEADER + '/communicationlist/modify',
    deletecommunicationlistData: Environment.API_HEADER + '/communicationlist/delete',
}



